import Api from 'api/v2/Api';
import axios from 'axios';

class TrialRecapApi extends Api {
  constructor() {
    super();
    this.baseUrl = 'api/v2/trial-features/recaps';
  }

  fetchTrialRecaps(features) {
    this.initialize();
    const featuresList = features.join(',');
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}?features=${featuresList}`));
  }
}

export default new TrialRecapApi();
